import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAtSymbol = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: "2.5em",
	height: "2.5em",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M25.694 29.965C23.181 30.926 15.513 32.495 11.354 27.71C7.32398 23.073 9.07298 16.056 12.09 12.548C14.816 9.37798 20.452 7.91198 25.39 9.91698C27.2019 10.6584 28.7254 11.9662 29.7327 13.6449C30.7401 15.3237 31.1773 17.2833 30.979 19.231C30.806 21.904 29.979 24.786 27.296 24.995C24.613 25.204 24.177 22.7 24 21.486C24.0251 19.3481 24.1845 17.2139 24.477 15.096C18.585 13.296 16.505 16.433 15.856 18.354C15.207 20.275 14.99 23.283 17.416 24.577C19.842 25.871 23.051 24.2 24 21.486",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeMiterlimit: 10
	})
});
const ForwardRef = forwardRef(SvgAtSymbol);
export default ForwardRef;
